export default {
  STATUS: [
    { KEY: 1, VALUE: 'ATIVA' },
    { KEY: 0, VALUE: 'INATIVA' },
  ],
  TYPE: [
    { KEY: 0, VALUE: 'R$' },
    { KEY: 1, VALUE: '%' },
  ],
  FARE: [
    { KEY: 0, VALUE: 'Origem' },
    { KEY: 1, VALUE: 'Destino' },
  ],
  WEEKDAYS: [
    { KEY: 'MONDAY', VALUE: 'Segunda' },
    { KEY: 'TUESDAY', VALUE: 'Terça' },
    { KEY: 'WEDNESDAY', VALUE: 'Quarta' },
    { KEY: 'THURSDAY', VALUE: 'Quinta' },
    { KEY: 'FRIDAY', VALUE: 'Sexta' },
    { KEY: 'SATURDAY', VALUE: 'Sábado' },
    { KEY: 'SUNDAY', VALUE: 'Domingo' },
    { KEY: 'HOLIDAYS', VALUE: 'Feriados' },
  ],
};
